import { Ajax } from '/asg/utilities/js/modules/ajax.js';
import { addListenerToClassElements } from '/asg/utilities/js/modules/add_listener_to_class_elements.js';

const contactDetailForms = document.querySelectorAll('.detail-contact');
const contactDetailSuccessDivs = document.querySelectorAll('.contact-success');
const contactDetailSuccessCloseLinks = document.querySelectorAll('.detail-success-close');

// Contact form
async function contactDetailFormSubmit(e) {
    e.preventDefault();
    let ajaxCaller = new Ajax;
    let contactDetailLoadingContainer = e.target.parentNode.querySelector('.loading-container-id');
    let contactErrors = e.target.parentNode.querySelector('.contact-errors');
    contactDetailLoadingContainer.classList.remove('hidden-v2');
    contactErrors.innerHTML = "";

    try {
        let contactDetailForm = e.target;
        let contactDetailSuccessDiv = e.target.parentNode.querySelector('.contact-success');

        const data = new URLSearchParams(new FormData(contactDetailForm));
        const responseData = await ajaxCaller.post(contactDetailForm.action, data);
        contactDetailLoadingContainer.classList.add('hidden-v2');
        contactDetailSuccessDiv.classList.remove('hidden-v2');
        contactDetailForm.classList.add('hidden-v2');

        try {
            ga('send', {
                'hitType' : 'pageview',
                'page' : '/search/detail/forms/'+String(currentMls)+'?submission-status=success&form_name=specific_property'
            });

            ga('send', {
                'hitType' : 'pageview',
                'page' : '/forms/specific-property-success?mls_number='+String(currentMls)
            });

            const category = "Form Submissions";
            const action = "Detail Contact";

            if (
                typeof contactDetailForm.dataset.origin !== 'undefined' &&
                contactDetailForm.dataset.origin &&
                contactDetailForm.dataset.origin != ''
            ) {
                const action = contactDetailForm.dataset.origin;
            }

            const label = ruri;
            //ga('send', 'event', category, action, label);
            ga('send', 'event', category, action, label);


            dataLayer.push({'event': 'gtm.formSubmit'});

        } catch(error) {
            console.log('logging error', error);
        }

    } catch(error) {
        console.log(error);
        let errorMarkup;
        if (typeof error.responseBody !== 'undefined' && typeof error.responseBody.errors !== 'undefined') {
            errorMarkup = '<ul>';
            for (let i = error.responseBody.errors.length - 1; i >= 0; i--) {
                errorMarkup += '<li>' + error.responseBody.errors[i] + '</li>';
            }
            errorMarkup += '</ul>';
            console.log(contactErrors);
        } else {
            errorMarkup = 'Unknown server error.  Please try again';
        }
        contactErrors.innerHTML = errorMarkup;
        contactErrors.classList.remove('hidden-v2');
        contactDetailLoadingContainer.classList.add('hidden-v2');
    }
}

function resetContactDetailFrom(e) {
    e.preventDefault();
    for (var i = 0; i < contactDetailSuccessDivs.length; i++) {
        contactDetailSuccessDivs[i].classList.add('hidden-v2');
    }
    for (var i = 0; i < contactDetailForms.length; i++) {
        contactDetailForms[i].classList.remove('hidden-v2');
    }
}

for (var i = 0; i < contactDetailForms.length; i++) {
    contactDetailForms[i].addEventListener('submit', contactDetailFormSubmit);
}

for (var i = 0; i < contactDetailSuccessCloseLinks.length; i++) {
    contactDetailSuccessCloseLinks[i].addEventListener('click', resetContactDetailFrom);
}


// Setup modal close buttons
function closeModal() {
    liteModal.close();
}
addListenerToClassElements('click', closeModal, 'lite-modal-close');

setInterval(function () {
    var actionsToLog = backlog;
    backlog = [];
    if (actionsToLog.length > 0) {
        for (var i = 0; i < actionsToLog.length; i++) {
            tracker.logVisitorActionBH('pa', actionsToLog[i]);
        }
    }
}, 1000);